import { Router } from './router/Router';
import { RouterProvider} from "react-router-dom";
import { Footer } from './views/components/Footer';
import { createTheme, ThemeProvider } from '@mui/material';
import { Colors } from './misc/variables';
import { SnackBarProvider } from './views/providers/SnackBarProvider';
import { DashboardDrawerProvider } from './views/providers/DashboardDrawerProvider';
import { useRef, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import store from './views/store/formStore';
import platformStore from './views/store/platformStore';

import { AuthHelper } from './views/controllers/AuthHelper';

import { itIT } from '@mui/x-date-pickers/locales';
import './App.css';

const originalFetch = window.fetch;

const theme = createTheme({
  palette: {
      mode: 'light',
      text: {
        primary: 'rgba(0,0,0,0.87)',
        secondary: 'rgba(220,220,220,0.54)',
        disabled: 'rgba(142,130,130,0.38)',
        hint: 'rgba(70,66,66,0.38)',
      },
      primary: {
        main: Colors.primaryColor
      },
      secondary: {
        main: Colors.secondaryColor
      }
  }
}, itIT);

function App() {
  const routerRef = useRef(null);
  const [onBehalfValue, setOnBehalfValue] = useState(null);

  useEffect(() => {
    const fetchUserAttributes = async () => {
      try {
        const attributes = await AuthHelper.getUserFromIdToken();
        console.log('Initial attributes fetched in App.js', attributes);
        if (attributes && attributes.UserAttributes) {
          const onBehalfAttr = attributes.UserAttributes.find(attr => attr.Name === 'custom:onbehalf');
          setOnBehalfValue(onBehalfAttr ? onBehalfAttr.Value : null);
        } else {
           console.warn("App.js: No attributes returned from AuthHelper.getUserFromIdToken.");
           setOnBehalfValue(null);
        }
      } catch (error) {
        console.error("App.js: Error fetching initial user data:", error);
        setOnBehalfValue(null);
      }
    };

    fetchUserAttributes();
  }, []);

  useEffect(() => {
    const fetchWrapper = async (resource, config = {}) => {
      try {
        // 1. Clonare la configurazione originale
        const newConfig = { 
          method: config.method || 'GET',
          headers: new Headers(config.headers),
          ...config 
        };

        // 2. Ottenere il token aggiornato
        const user = await AuthHelper.getUserFromIdToken();
        const onBehalf = user?.UserAttributes?.find(
          attr => attr.Name === 'custom:onbehalf'
        )?.Value;

        // 3. Aggiungere l'header solo se presente
        if (onBehalf) {
          newConfig.headers.set('x-onbehalf', onBehalf);
          console.log('Header aggiunto:', onBehalf);
        }

        // 4. Eseguire la richiesta originale con la nuova configurazione
        const response = await originalFetch(resource, newConfig);
        
        // 5. Gestione degli errori HTTP
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;

      } catch (error) {
        console.error('Interceptor error:', error);
        throw error;
      }
    };

    // Sostituire il fetch globale
    window.fetch = fetchWrapper;

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={platformStore}>
        <Provider store={store}>
          <SnackBarProvider>
            <DashboardDrawerProvider routerContext={Router}>
                <div className="App">
                    
                    <div className="page">
                      <RouterProvider router={Router} ref={routerRef} />
                    </div>
                </div>
            </DashboardDrawerProvider>
            </SnackBarProvider>
        </Provider>
      </Provider>
    </ThemeProvider>
    
  );
}

export default App;
